import { takeEvery } from '@zaibot/fsa-saga';
import { delay } from 'redux-saga';
import { isType } from '@zaibot/fsa';
import { call, fork, put } from '../../redux-saga';
import { IBookmark, INote, isCategory, isUsergroup, IUsergroup } from '../../types';
import { hack } from '../../browser/launch';
import ADMIN_HIDE from '../admin/actions/HIDE';
import SELECTION_REQUEST from '../selection/actions/REQUEST';
import SELECTION_RESET from '../selection/actions/RESET';
import HIDE from './actions/HIDE';
import SHOW from './actions/SHOW';
import SHOW_FLYOVER from '../flyover/actions/SHOW';
import REFRESH_BOOKMARKUPDATE from './actions/REFRESH_BOOKMARKUPDATE';
import UPDATE_BUTTON_NO, { buttonNotitiesToevoegenFlyover, originAdmin, originFlyover, originNoteMenu, buttonDropDownCategory, buttonDropDownSorting, GetDelay, buttonAdminNotitiesButton, itemButtonTypeActionBewerkenItem, itemButtonTypeActionDeleteItem, itemButtonTypeActionBewerkenCategory, itemButtonTypeActionDeleteCategory, itemButtonTypeActionBewerkenBookmark, itemButtonTypeActionBewerkenUsergroup, buttonUsergroupCreeerDeelnemers } from '../../focuslock/actions/UPDATE_BUTTON_NO';
import RELEASE_BUTTON_LOCK from '../../focuslock/actions/RELEASE_BUTTON_LOCK';    
import UPDATED_BUTTON_LOCK from '../../focuslock/actions/UPDATED_BUTTON_LOCK';    
import { buttonMijnItems } from '../../focuslock/actions/UPDATE_BUTTON_NO';
import { bookmarksEditor, bookmarksResource } from '../bookmarks/resource';
import { notesEditor } from '../notes/resource';
import { isNote } from '../../types';
import adminReselectors from '../admin/reselectors';
import PAGEFILTER_TOGGLE_CATEGORY from '../pageFilter/actions/PAGEFILTER_TOGGLE_CATEGORY';
import PAGEFILTER_SHOW from '../pageFilter/actions/SHOW';
import PAGEFILTER_TOGGLE_SORTING from '../pageFilter/actions/PAGEFILTER_TOGGLE_SORTING';
import { categoriesEditor } from '../categories/resource';
import USERGROUP_UPDATED from '../../usergroup/actions/USERGROUP_UPDATED';
import USERGROUP_CREATED from '../../usergroup/actions/USERGROUP_CREATED';
import NOTES_INITIALIZE from '../notes/actions/NOTES_INITIALIZE';

function* watchButtonActions() {
    yield takeEvery([   
        SELECTION_REQUEST,
    ], function*(action) {       
        const origin=hack.store.getState().notemenu.origin;
        if (origin===originNoteMenu)
            yield put(HIDE({}));
    });
} 

function* signalEndNotesEdit() {
    yield takeEvery([
        notesEditor.actions.CREATE_CONTINUE, 
        notesEditor.actions.UPDATE_CONTINUE,
        notesEditor.actions.CREATE_CANCEL,
        notesEditor.actions.UPDATE_CANCEL,
    ], function*(action) {  
        yield put(NOTES_INITIALIZE({initialize: false}));
    });
}

function* signalBeginNotesEdit() {
    yield takeEvery([
        notesEditor.actions.CREATE, 
        notesEditor.actions.UPDATE,
    ], function*(action) {        
        const delayDispatch = 200;
        yield call(delay, delayDispatch),
        yield put(NOTES_INITIALIZE({initialize: true}));
    });
}

function* signalReturnFromSelection() {
    yield takeEvery([
        SELECTION_RESET, 
        // notesEditor.actions.RESET, 
        notesEditor.actions.CREATE_CONTINUE, 
        notesEditor.actions.UPDATE_CONTINUE,
        notesEditor.actions.CREATE_CANCEL,
        notesEditor.actions.UPDATE_CANCEL, 
        categoriesEditor.actions.CREATE_CONTINUE,
        categoriesEditor.actions.UPDATE_CONTINUE,
        categoriesEditor.actions.CREATE_CANCEL,
        categoriesEditor.actions.UPDATE_CANCEL,
        bookmarksEditor.actions.CREATE_CONTINUE, 
        bookmarksEditor.actions.UPDATE_CONTINUE,
        bookmarksEditor.actions.CREATE_CANCEL,
        bookmarksEditor.actions.UPDATE_CANCEL,
        USERGROUP_UPDATED,
        USERGROUP_CREATED,
    ], function*(action) {   
        const origin=hack.store.getState().notemenu.origin;
        const lasttoucheditem=hack.store.getState().notemenu.lasttoucheditem;  

        if (isType(action, USERGROUP_CREATED)) {         
                // tslint:disable-next-line
                yield delay(500);
                yield put(UPDATE_BUTTON_NO({buttonNo: buttonUsergroupCreeerDeelnemers, origin: originAdmin, buttonAction: itemButtonTypeActionBewerkenUsergroup}));      
        } else if (isType(action, USERGROUP_UPDATED)) {
            let usergroup: IUsergroup|any = action.payload.usergroup;         
            if (isUsergroup(usergroup)) {
                 // tslint:disable-next-line
                yield delay(500);
                yield put(UPDATE_BUTTON_NO({buttonNo: usergroup.id, origin: originAdmin, buttonAction: itemButtonTypeActionBewerkenUsergroup}));                        
            }            
        }  else if (origin===originNoteMenu) {       
            // if (buttonNo!==buttonLogout) {
            //     yield put(SHOW({buttonNo: buttonNotitiesToevoegen, origin: originNoteMenu}));                
            // } else {
            //     yield put(SHOW({buttonNo: buttonLogout, origin: originNoteMenu}));
            // }
        } else if (origin===originAdmin) {            
            let itm: INote|any = action.payload;              
            if (isNote(itm.item)) {
                yield put(UPDATE_BUTTON_NO({buttonNo: itm.item.id, origin: originAdmin, buttonAction: itemButtonTypeActionBewerkenItem}));
            } else if (isNote(lasttoucheditem)) {
                // tslint:disable-next-line
                yield delay(300);
                yield put(UPDATE_BUTTON_NO({buttonNo: lasttoucheditem.id, origin: originAdmin, buttonAction: itemButtonTypeActionBewerkenItem}));
            } else if (isCategory(lasttoucheditem)) {                
                // tslint:disable-next-line
                yield delay(300);
                yield put(UPDATE_BUTTON_NO({buttonNo: lasttoucheditem.id, origin: originAdmin, buttonAction: itemButtonTypeActionBewerkenCategory}));            
            } else if (lasttoucheditem) {
                // Bookmarks
                // tslint:disable-next-line
                yield delay(300);
                yield put(UPDATE_BUTTON_NO({buttonNo: lasttoucheditem.id, origin: originAdmin, buttonAction: itemButtonTypeActionBewerkenBookmark}));
            } else {
                yield put(UPDATE_BUTTON_NO({buttonNo: buttonAdminNotitiesButton, origin: originAdmin}));
            }

        }    
    
    });
}

function determineClosest(prev: number, curr: number, value: number) {
    if (value===curr) return prev;
    return (Math.abs(curr - value) < Math.abs(prev - value)                   
        ? curr : prev);
}

function* signalReturnFromDeletion() {
    yield takeEvery([
        notesEditor.actions.DELETE_CANCEL, 
        notesEditor.actions.DELETE_CONTINUE,
        categoriesEditor.actions.DELETE_CANCEL,
        categoriesEditor.actions.DELETE_CONTINUE,        
    ], function*(action) {    
        const origin=hack.store.getState().notemenu.origin;  
        const lasttoucheditem=hack.store.getState().notemenu.lasttoucheditem;
    
        if (origin===originAdmin) {   
            let itm: any = action.payload;
            if (isNote(itm.item)) { 
                if (isType(action, notesEditor.actions.DELETE_CONTINUE)) {
                    const items=adminReselectors.notesItemsSelector(hack.store.getState());
                    var closest = items.map((x) => x.id).
                                    reduce((prev, curr) => determineClosest(prev, curr, itm.item.id));
                    yield put(UPDATE_BUTTON_NO({buttonNo: closest, origin: originAdmin, buttonAction: itemButtonTypeActionDeleteItem}));
                } else {                
                    yield put(UPDATE_BUTTON_NO({buttonNo: itm.item.id, origin: originAdmin, buttonAction: itemButtonTypeActionDeleteItem}));                  
                } 
            } 
            if (isCategory(itm.item)) { 
                if (isType(action, notesEditor.actions.DELETE_CONTINUE)) {
                    const items=adminReselectors.categoriesItemsSelector(hack.store.getState());
                    var closest = items.map((x) => x.id).
                                    reduce((prev, curr) => determineClosest(prev, curr, itm.item.id));
                    yield put(UPDATE_BUTTON_NO({buttonNo: closest, origin: originAdmin, buttonAction: itemButtonTypeActionDeleteCategory}));
                } else {                
                    yield put(UPDATE_BUTTON_NO({buttonNo: itm.item.id, origin: originAdmin, buttonAction: itemButtonTypeActionDeleteCategory}));                  
                } 
            }  else { 
                if (isNote(lasttoucheditem)) {
                    yield put(UPDATE_BUTTON_NO({buttonNo: lasttoucheditem.id, origin: originAdmin, buttonAction: itemButtonTypeActionDeleteItem}));
                } else if (isCategory(lasttoucheditem)) { 
                    yield put(UPDATE_BUTTON_NO({buttonNo: lasttoucheditem.id, origin: originAdmin, buttonAction: itemButtonTypeActionDeleteCategory}));
                }
            }
        }      
    });
}

function* signalReturnFromMyItems() {
    yield takeEvery([
        ADMIN_HIDE,
    ], function*(action) {   
        yield put(SHOW({buttonNo: buttonMijnItems, origin: originNoteMenu}));
    });
}

function* watchBookmarkButtonActions() {
    yield takeEvery([
        REFRESH_BOOKMARKUPDATE,
    ], function*(action) {
        if (action.payload.add) {         
            // hack.store.dispatch(bookmarksResource.actions.CREATE({ item: bookmarksResource.create(action.payload.item) as IBookmark }));
            yield put(bookmarksResource.actions.CREATE({ item: bookmarksResource.create(action.payload.item) as IBookmark }));
        } else {
            // hack.store.dispatch(bookmarksResource.actions.DELETE({ item: action.payload.item }));
            yield put(bookmarksResource.actions.DELETE({ item: action.payload.item }));
        }
    });
}

function* signalUpdatebutton() {
    yield takeEvery([
        SHOW,
    ], function*(action) {  

        yield put(UPDATE_BUTTON_NO({buttonNo: action.payload.buttonNo,
                                     origin: originNoteMenu }));
    });
}

function* signalUpdatebuttonFlyover() {
    yield takeEvery([
        SHOW_FLYOVER,
    ], function*(action) {  

        if (action.payload.buttonNo===buttonNotitiesToevoegenFlyover) {
            yield put(UPDATE_BUTTON_NO({buttonNo: action.payload.buttonNo, 
                     origin: originFlyover }));
        }
    });
}

function* signalReleaselock() {
    yield takeEvery([
        UPDATED_BUTTON_LOCK,
    ], function*(action) {   
        // console.log(action.payload.buttonNo);
        // console.log(action.payload.origin);        
        // console.log(action.payload.buttonAction);        
        yield delay(GetDelay(action.payload.buttonNo));    
        yield put(RELEASE_BUTTON_LOCK({buttonNo: action.payload.buttonNo,
                                        origin: action.payload.origin,
                                        buttonAction: action.payload.buttonAction}));
    });
}

function* signalChangeFilterCategory() {
    yield takeEvery([
        PAGEFILTER_TOGGLE_CATEGORY, PAGEFILTER_SHOW,
    ], function*(action) {  
        yield put(UPDATE_BUTTON_NO({buttonNo: buttonDropDownCategory, origin: originFlyover}));      
    });
}
function* signalChangeFilterSorting() {
    yield takeEvery([
        PAGEFILTER_TOGGLE_SORTING,
    ], function*(action) {  
        yield put(UPDATE_BUTTON_NO({buttonNo: buttonDropDownSorting, origin: originFlyover}));      
    });
}

export function* rootSaga(): Iterable<any> {
    yield fork(watchButtonActions);
    yield fork(signalReturnFromSelection);
    yield fork(signalReturnFromDeletion);
    yield fork(signalReturnFromMyItems);     
    yield fork(signalUpdatebutton); 
    yield fork(signalUpdatebuttonFlyover);
    yield fork(signalReleaselock);       
    yield fork(watchBookmarkButtonActions);     
    yield fork(signalChangeFilterCategory);
    yield fork(signalChangeFilterSorting);
    yield fork(signalEndNotesEdit);
    yield fork(signalBeginNotesEdit);
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/notemenu/sagas.tsx